<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="1000"
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="eSIM入库"
      @ok="handleSubmit"
    >
      <a-row>
        <a-form
          class="simiot-compact-form"
          :form="form"
          :label-col="{ span: 9 }"
          :wrapper-col="{ span: 14 }"
          @submit="handleSubmit"
        >
          <a-col :span="11">
            <a-form-item :wrapper-col="{ span: 24 }">
              <a-textarea
                :rows="32"
                :placeholder="eidPlaceholder"
                :style="{ color: eidValidateStatus === 'error' ? 'red' : '' }"
                v-model.trim="eidInput"
                @blur="analyzeEidInput"
              />
            </a-form-item>
            <a-form-item label="EID总数" :style="{ display: 'inline-block', width: '50%' }">
              <span>{{ eidsCount }}</span>
            </a-form-item>
            <a-form-item label="重复数量" :style="{ display: 'inline-block', width: '50%' }">
              <span>{{ duplicateEidsCount }}</span>
            </a-form-item>
            <div v-if="eidErrorMsg" style="color: red">{{ eidErrorMsg }}</div>
          </a-col>

          <a-col :span="13">
            <a-form-item label="库房位置">
              <a-select
                v-decorator="['warehouse_location_id', { rules: [{ required: true, message: '请选择库房位置' }] }]"
                show-search
                option-filter-prop="children"
                :loading="loadingWarehouseOptions"
              >
                <a-select-option v-for="opt in warehouseOptions" :key="opt.id" :value="opt.id">
                  {{ opt.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="eSIM供应商">
              <a-select
                v-decorator="['esim_supplier_id', { rules: [{ required: true, message: '请选择eSIM供应商' }] }]"
                show-search
                option-filter-prop="children"
                :loading="loadingProducerOptions"
              >
                <a-select-option v-for="opt in producerOptions" :key="opt.id" :value="opt.id">
                  {{ opt.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="SGP规范">
              <a-checkbox-group
                v-decorator="['sgp_spec_ids', { rules: [{ required: true, message: '请选择SGP规范' }] }]"
                :options="sgpSpecCheckboxOptions"
              />
            </a-form-item>

            <a-form-item label="LPA/IPA">
              <a-select
                v-decorator="['lpa_ipa_id', { rules: [{ required: true, message: '请选择LPA/IPA' }] }]"
                show-search
                option-filter-prop="children"
                :loading="loadingLpaIpaOptions"
              >
                <a-select-option v-for="opt in lpaIpaOptions" :key="opt.id" :value="opt.id">
                  {{ opt.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="是否有预制号">
              <a-radio-group
                v-decorator="['has_preconfigured_number', {
                  initialValue: false,
                  rules: [{ required: true, message: '请选择是否有预制号' }]
                }]"
              >
                <a-radio :value="true">是</a-radio>
                <a-radio :value="false">否</a-radio>
              </a-radio-group>
            </a-form-item>

            <a-form-item v-if="showPreconfiguredNumberFallback" label="预制号是否用作Fallback">
              <a-radio-group
                v-decorator="['is_preconfigured_number_fallback', {
                  initialValue: false,
                  rules: [{ required: true, message: '请选择预制号是否用作Fallback' }]
                }]"
              >
                <a-radio :value="true">是</a-radio>
                <a-radio :value="false">否</a-radio>
              </a-radio-group>
            </a-form-item>

            <a-form-item label="是否预制默认SM-DP+">
              <a-radio-group
                v-decorator="['has_preconfigured_default_smdp', {
                  initialValue: false,
                  rules: [{ required: true, message: '请选择是否预制默认SM-DP+' }]
                }]"
              >
                <a-radio :value="true">是</a-radio>
                <a-radio :value="false">否</a-radio>
              </a-radio-group>
            </a-form-item>

            <a-form-item v-if="showSmdpAddress" label="SM-DP+地址">
              <a-input
                v-decorator="['smdp_address', {
                  rules: [
                    { required: true, message: '请填写SM-DP+地址' },
                    { max: 255, message: '最多255个字符' }
                  ]
                }]"
                placeholder="请输入SM-DP+地址"
              />
            </a-form-item>

            <a-form-item label="是否预制根SM-DS">
              <a-radio-group
                v-decorator="['has_preconfigured_root_smds', {
                  initialValue: false,
                  rules: [{ required: true, message: '请选择是否预制根SM-DS' }]
                }]"
              >
                <a-radio :value="true">是</a-radio>
                <a-radio :value="false">否</a-radio>
              </a-radio-group>
            </a-form-item>

            <a-form-item v-if="showSmdsAddress" label="SM-DS地址">
              <a-input
                v-decorator="['smds_address', {
                  rules: [
                    { required: true, message: '请填写SM-DS地址' },
                    { max: 255, message: '最多255个字符' }
                  ]
                }]"
                placeholder="请输入SM-DS地址"
              />
            </a-form-item>

            <a-form-item label="eIM平台">
              <a-select
                v-decorator="['eim_platform_id', { rules: [{ required: true, message: '请选择eIM平台' }] }]"
                :loading="loadingEimPlatformOptions"
              >
                <a-select-option v-for="opt in eimPlatformOptions" :key="opt.id" :value="opt.id">
                  {{ opt.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="卡片材质">
              <a-select
                v-decorator="['card_type_id', { rules: [{ required: true, message: '请选择卡片材质' }] }]"
                :loading="loadingCardTypeOptions"
                @change="handleCardTypeChange"
              >
                <a-select-option v-for="opt in cardTypeOptions" :key="opt.id" :value="opt.id">
                  {{ opt.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="卡片尺寸">
              <a-select
                v-decorator="['card_shape_name', { rules: [{ required: true, message: '请选择卡片尺寸' }] }]"
                :loading="loadingCardShapeOptions"
              >
                <a-select-option v-for="opt in cardShapeOptions" :key="opt.name" :value="opt.name">
                  {{ opt.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="生产日期">
              <a-date-picker
                v-decorator="['production_date', { rules: [{ required: true, message: '请选择生产日期' }] }]"
                style="width: 100%"
                value-format="YYYY-MM-DD"
              />
            </a-form-item>

            <a-form-item label="制卡费(元)">
              <a-input-number
                v-decorator="['card_fee', { initialValue: 0, rules: [{ validator: checkCardFee }] }]"
                :min="0"
                :precision="3"
                :step="0.001"
                style="width: 100%"
                @change="(v) => { this.cardFeeWatch = v }"
              />
            </a-form-item>

            <a-form-item label="总制卡费预览">
              <span>{{ totalCardFeePreview }}</span>
            </a-form-item>

            <a-form-item label="备注">
              <a-textarea
                v-decorator="['remark', { rules: [{ max: 200, message: '最多200个字符' }] }]"
                :auto-size="{ minRows: 3, maxRows: 5 }"
              />
            </a-form-item>
          </a-col>
        </a-form>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { findCommonTypeOptions } from '@/api/common_type'
import { findEsimSuppliers } from '@/api/esim_supplier'
import { findCardTypeOptions, findCardShapeOptions } from '@/api/common_options'
import { importEsimInventories } from '@/api/esim_inventory'
import { formatFloat } from '@/utils/filter'
import { analyzeEids, maxEidLines } from '@/utils/eid'

export default {
  name: 'ImportEsimInventory',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, {
        name: 'import_esim_inventories',
        onValuesChange: this.onValuesChange
      }),
      submitting: false,
      eidInput: '',
      eids: [],
      eidsCount: 0,
      duplicateEidsCount: 0,
      eidValidateStatus: '',
      eidErrorMsg: '',
      eidPlaceholder: '可以直接复制excel中整列EID；\n' +
        '手动输入多个EID，一行一个，EID固定32位；\n' +
        '连号的EID只需要输入最后几位不一样的即可，用波浪线连接。\n' +
        '例如: 89049032005008820000000000000100~150',
      producerOptions: [],
      sgpSpecOptions: [],
      lpaIpaOptions: [],
      warehouseOptions: [],
      eimPlatformOptions: [],
      cardTypeOptions: [],
      cardShapeOptions: [],
      loadingProducerOptions: false,
      loadingSgpSpecOptions: false,
      loadingLpaIpaOptions: false,
      loadingWarehouseOptions: false,
      loadingEimPlatformOptions: false,
      loadingCardTypeOptions: false,
      loadingCardShapeOptions: false,
      cardFeeWatch: 0,
      showPreconfiguredNumberFallback: false,
      showSmdpAddress: false,
      showSmdsAddress: false
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    totalCardFeePreview() {
      const fee = Number(this.cardFeeWatch || 0)
      return formatFloat(fee * this.eidsCount)
    },
    sgpSpecCheckboxOptions() {
      return (this.sgpSpecOptions || []).map((opt) => ({
        label: opt.name,
        value: opt.id
      }))
    }
  },
  created() {
    this.fetchProducerOptions()
    this.fetchSgpSpecOptions()
    this.fetchLpaIpaOptions()
    this.fetchWarehouseOptions()
    this.fetchEimPlatformOptions()
    this.fetchCardTypeOptions()
  },
  methods: {
    onValuesChange(props, values) {
      if (values.has_preconfigured_number !== undefined) {
        this.showPreconfiguredNumberFallback = !!values.has_preconfigured_number
        if (!values.has_preconfigured_number) {
          this.form.setFieldsValue({ is_preconfigured_number_fallback: false })
        }
      }
      if (values.has_preconfigured_default_smdp !== undefined) {
        this.showSmdpAddress = !!values.has_preconfigured_default_smdp
        if (!values.has_preconfigured_default_smdp) {
          this.form.setFieldsValue({ smdp_address: undefined })
        }
      }
      if (values.has_preconfigured_root_smds !== undefined) {
        this.showSmdsAddress = !!values.has_preconfigured_root_smds
        if (!values.has_preconfigured_root_smds) {
          this.form.setFieldsValue({ smds_address: undefined })
        }
      }
    },

    checkCardFee(rule, value, callback) {
      if (value == null || value === '') {
        callback()
        return
      }
      if (Number(value) < 0) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('制卡费不能为负')
        return
      }
      callback()
    },

    fetchProducerOptions() {
      this.loadingProducerOptions = true
      findEsimSuppliers({ page: 1, per_page: 500 }).then((res) => {
        if (res.code === 0) this.producerOptions = res.data
        this.loadingProducerOptions = false
      })
    },

    fetchSgpSpecOptions() {
      this.loadingSgpSpecOptions = true
      findCommonTypeOptions('product_esim_sgp_spec').then((res) => {
        if (res.code === 0) this.sgpSpecOptions = res.data
        this.loadingSgpSpecOptions = false
      })
    },

    fetchLpaIpaOptions() {
      this.loadingLpaIpaOptions = true
      findCommonTypeOptions('product_esim_lpa_ipa').then((res) => {
        if (res.code === 0) this.lpaIpaOptions = res.data
        this.loadingLpaIpaOptions = false
      })
    },

    fetchWarehouseOptions() {
      this.loadingWarehouseOptions = true
      findCommonTypeOptions('warehouse_location').then((res) => {
        if (res.code === 0) this.warehouseOptions = res.data
        this.loadingWarehouseOptions = false
      })
    },

    fetchEimPlatformOptions() {
      this.loadingEimPlatformOptions = true
      findCommonTypeOptions('eim_platform').then((res) => {
        if (res.code === 0) this.eimPlatformOptions = res.data
        this.loadingEimPlatformOptions = false
      })
    },

    fetchCardTypeOptions() {
      this.loadingCardTypeOptions = true
      findCardTypeOptions().then((res) => {
        if (res.code === 0) this.cardTypeOptions = res.data
        this.loadingCardTypeOptions = false
      })
    },

    handleCardTypeChange(cardTypeId) {
      this.form.setFieldsValue({ card_shape_name: undefined })
      this.cardShapeOptions = []
      if (!cardTypeId) return
      this.loadingCardShapeOptions = true
      findCardShapeOptions(cardTypeId).then((res) => {
        if (res.code === 0) this.cardShapeOptions = res.data
        this.loadingCardShapeOptions = false
      })
    },

    analyzeEidInput() {
      if (!this.eidInput) {
        this.eids = []
        this.eidsCount = 0
        this.duplicateEidsCount = 0
        this.eidValidateStatus = 'error'
        this.eidErrorMsg = '请录入 EID'
        return
      }

      const { lines, validEids, errorText } = analyzeEids(this.eidInput)
      if (lines > maxEidLines) {
        this.eids = []
        this.eidsCount = 0
        this.duplicateEidsCount = 0
        this.eidValidateStatus = 'error'
        this.eidErrorMsg = `EID数量不能超过${maxEidLines}`
        return
      }

      this.eidInput = errorText + validEids.join('\n')
      this.eids = this.$lodash.uniq(validEids)
      this.eidsCount = validEids.length
      this.duplicateEidsCount = validEids.length - this.eids.length

      if (errorText) {
        this.eidValidateStatus = 'error'
        this.eidErrorMsg = '号码包含错误，无法提交（EID须为32位）'
      } else if (this.eids.length === 0) {
        this.eidValidateStatus = 'error'
        this.eidErrorMsg = '请录入 EID'
      } else if (this.duplicateEidsCount > 0) {
        this.eidValidateStatus = 'error'
        this.eidErrorMsg = '录入的 EID 存在重复'
      } else {
        this.eidValidateStatus = 'success'
        this.eidErrorMsg = ''
      }
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({ title: '请勿重复提交', content: '' })
        return
      }
      this.analyzeEidInput()
      if (this.eidValidateStatus === 'error') {
        return
      }

      this.form.validateFields((err, values) => {
        if (err) return
        this.submitting = true
        const hasNumber = !!values.has_preconfigured_number
        const hasSmdp = !!values.has_preconfigured_default_smdp
        const hasSmds = !!values.has_preconfigured_root_smds
        const data = {
          eids: this.eids,
          warehouse_location_id: values.warehouse_location_id,
          esim_supplier_id: values.esim_supplier_id,
          sgp_spec_ids: values.sgp_spec_ids || [],
          lpa_ipa_id: values.lpa_ipa_id,
          has_preconfigured_number: hasNumber,
          is_preconfigured_number_fallback: hasNumber ? !!values.is_preconfigured_number_fallback : false,
          has_preconfigured_default_smdp: hasSmdp,
          smdp_address: hasSmdp ? (values.smdp_address || '') : '',
          has_preconfigured_root_smds: hasSmds,
          smds_address: hasSmds ? (values.smds_address || '') : '',
          eim_platform_id: values.eim_platform_id,
          card_type_id: values.card_type_id,
          card_shape_name: values.card_shape_name,
          production_date: values.production_date,
          card_fee: values.card_fee == null ? 0 : Number(values.card_fee),
          remark: values.remark || ''
        }
        importEsimInventories(data).then((res) => {
          if (res.code === 0) {
            this.isShow = false
            this.$emit('completed')
            this.$success({
              title: '提交成功',
              content: (
                <div>
                  <p>操作成功，具体结果请至 【eSIM资源入库】-【入库记录】 查看</p>
                </div>
              )
            })
          }
          this.submitting = false
        }).catch(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>
